import { useEffect, useState } from "react";
import { postStoreMonthlyCovers } from "../../services/AllServices";
import { downloadCSV, showMessage } from "../../utils/helpers";

const useReplenishmentUploadViewController = () => {
    const [uploadFile, setUploadFile] = useState(null);
    const [enableUpload, setEnableUpload] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileName, setFileName] = useState("");

    useEffect(() => {
        if (uploadFile) {
            setEnableUpload(true);
        } else {
            setEnableUpload(false);
        }
    }, [uploadFile]);

    const onContinue = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("monthly_covers_csv", uploadFile);
        try {
            const responseData = await postStoreMonthlyCovers(formData);
            if (responseData.data) {
                showMessage("success", responseData.message);
            } else {
                showMessage("error", responseData.message || "Something went wrong");
            }
        } catch (error) {
            console.error(error);
            showMessage("error", error?.data?.message || "Something went wrong");
        } finally {
            setUploadFile(null);
            setFileName("");
            setLoading(false);
        }
    }


    const downloadSampleCSV = () => {
        downloadCSV(process.env.PUBLIC_URL + "/MonthlyCoversSample.csv","Monthly Covers Sample.csv");
    }


    return {
        setUploadFile,
        onContinue,
        enableUpload,
        loading,
        uploadFile,
        fileName,
        setFileName,
        downloadSampleCSV
    };
};

export default useReplenishmentUploadViewController;